export default __webpack_public_path__ + "static/media/greek-kick-wreath.a92f8f93.svg";